// Copyright (c) StrangeBee 2023

type CaseCreateScratchSteps = 'createScratch';

type CaseCreateTemplateSteps = 'chooseTemplate' | 'createTemplate';

export type CaseCreateStep = {
    index: number;
    label: string;
};

export type CaseCreateScratchStepsRecord = Record<CaseCreateScratchSteps, CaseCreateStep>;

export type CaseCreateTemplateStepsRecord = Record<CaseCreateTemplateSteps, CaseCreateStep>;

export const CaseCreateScratchStepsOrdered: CaseCreateScratchStepsRecord = {
    createScratch: {
        index: 1,
        label: 'create-scratch',
    },
};

export const CaseCreateImportedStepsOrdered: CaseCreateScratchStepsRecord = {
    createScratch: {
        index: 1,
        label: 'create-import',
    },
};

export const CaseCreateTemplateStepsOrdered: CaseCreateTemplateStepsRecord = {
    chooseTemplate: {
        index: 1,
        label: 'choose-template',
    },
    createTemplate: {
        index: 2,
        label: 'create-template',
    },
};

export const CaseCreateStepsOrdered = {
    choose: {
        index: 0,
        label: 'choose',
    },
    scratch: CaseCreateScratchStepsOrdered,
    import: CaseCreateImportedStepsOrdered,
    template: CaseCreateTemplateStepsOrdered,
};

export const FREETAGS_NAMESPACE = '_freetags_';
